module.exports = __webpack_public_path__ + "assets/f0f8dc0bfd37d2eba76e0d6b37c33231.svg";